import { BaseApi, CancelTokenKeyCommit } from '@/main/baseApi';
import { SET_CANCEL_TOKEN } from '@/main/store/listEditTypes';

import { DMS_MODULE, NAME } from './constants';

class PracovniPoziceProvider extends BaseApi {
	getTextPp(vyrobekVozOzn: string | number, ppNr: string | number, tablpozice: string | number) {
		return this.fetch(
			`/${DMS_MODULE}/${NAME}/GetTextPp?vyrobekVozOzn=${vyrobekVozOzn}&ppNr=${ppNr}&tablpozice=${tablpozice}`,
		);
	}

	getTextPpTz(vyrobekVozOzn: string | number, ppNr: string | number, tablpozice: string | number) {
		return this.fetch(
			`/${DMS_MODULE}/${NAME}/GetTextPpTz?vyrobekVozOzn=${vyrobekVozOzn}&ppNr=${ppNr}&tablpozice=${tablpozice}`,
		);
	}

	tableSchema({ cancelTokenKey, commit }: CancelTokenKeyCommit = { cancelTokenKey: null, commit: null }, type: number = 0) {
		const cancelPtr = cancelTokenKey ? { value: null } : null;
		const resp = this.fetch(`${this.apiPath}Schema`, { type });

		cancelTokenKey && commit!(SET_CANCEL_TOKEN, { cancelTokenKey, token: cancelPtr!.value });

		return resp;
	}

	tableSchemaSelect({ cancelTokenKey, commit }: CancelTokenKeyCommit = { cancelTokenKey: null, commit: null }, type: number = 0) {
		const cancelPtr = cancelTokenKey ? { value: null } : null;
		const resp = this.fetch(`${this.apiPath}SelectSchema`, { type });

		cancelTokenKey && commit!(SET_CANCEL_TOKEN, { cancelTokenKey, token: cancelPtr!.value });

		return resp;
	}
	async saveTable(table: any) {
		return this.update(`/${DMS_MODULE}/${NAME}`, table);
	}
}

export const apiProvider = new PracovniPoziceProvider(DMS_MODULE, NAME);
